const enum LocalConstants {
  SportsOfferingBase = 'kambi-sports-offering',
}

export const sportsOfferingQueryKeys = {
  SportsOfferingBase: [LocalConstants.SportsOfferingBase],

  BetOffersByIds: (betOfferIds: number[]) => [
    LocalConstants.SportsOfferingBase,
    'bet-offers-by-ids',
    ...betOfferIds,
  ],

  EventGroupsFromRoot: [LocalConstants.SportsOfferingBase, 'groups', 'events-groups-from-root'],
  EventGroupHighlights: [LocalConstants.SportsOfferingBase, 'groups', 'highlight'],
  EventsForGroupId: (groupId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'group',
    groupId ?? 'null',
    'events',
  ],
  SgmAvailabilityForGroup: (groupId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'group',
    groupId ?? 'null',
    'sgm-availability',
  ],
  SgmAvailabilityForEvent: (eventId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'event',
    eventId ?? 'null',
    'sgm-availability',
  ],
  EventsForSport: (sport: string) => [LocalConstants.SportsOfferingBase, 'sport', sport, 'events'],
  BetOffersByEvents: (eventIds: number[]) => [
    LocalConstants.SportsOfferingBase,
    'betoffers',
    'events',
    ...eventIds,
  ],
  BetOffersByGroups: (groupIds: number[]) => [
    LocalConstants.SportsOfferingBase,
    'betoffers',
    'groups',
    ...groupIds,
  ],
  UpcomingEventsForAllSports: [
    LocalConstants.SportsOfferingBase,
    'events',
    'upcoming',
    'all-sports',
  ],
  LiveEventsForAllSports: [LocalConstants.SportsOfferingBase, 'events', 'live', 'all-sports'],
  CashOutSpecialEventsForAllSports: [LocalConstants.SportsOfferingBase, 'events', 'cash-out'],
  Group: (groupId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'group',
    groupId ?? 'null',
  ],
  EventsForCompetition: (sport: string, region: string, competition: string) => [
    LocalConstants.SportsOfferingBase,
    'sport',
    sport,
    region,
    competition,
  ],
  BetOffersPrepackByEvents: (eventIds: number[]) => [
    LocalConstants.SportsOfferingBase,
    'event',
    'prepack',
    ...eventIds,
  ],
  EventPricingForEvent: (eventId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'event',
    eventId ?? 'null',
    'pricing',
  ],
  ParticipantsByLeague: (competitionId: number) => [
    LocalConstants.SportsOfferingBase,
    'league',
    'participants',
    competitionId,
  ],
} as const
